import axios from "axios";
import { toast } from "sonner";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("loket_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const msg = err?.response?.data?.detail || err?.message || "Terjadi kesalahan";
    const onLogin = window.location.pathname.startsWith("/login");
    if (err?.response?.status === 401) {
      if (onLogin) {
        // gagal login: tampilkan pesan yang jelas, jangan redirect diam-diam
        toast.error(String(msg) || "Username atau password salah");
      } else {
        localStorage.removeItem("loket_token");
        localStorage.removeItem("loket_user");
        window.location.href = "/login";
      }
    } else {
      toast.error(String(msg));
    }
    return Promise.reject(err);
  }
);

export default api;
